import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Google stoops to their level, fights freedom",
  "description": "",
  "published": "2009-11-26T00:00:00.000Z",
  "redirect_from": ["/blog/google-stoops-to-their-level-fights-freedom/swizec/904"],
  "categories": "food for thought, Google, intrigues, Politics, Racism, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In my usual fashion I'm a bit late to discover this bit of news, a day or so late. Naturally I still wanted to share my thoughts on the matter, I mean that's what blogging is about, our narcissistic tendencies to shout into the void and see if anyone will hear it.`}</p>
    <p>{`Last week an image surfaced on Google Image Search Results of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Michelle_Obama",
        "title": "Michelle Obama"
      }}>{`Michelle Obama`}</a>{` photoshopped to look like a monkey. It was first hit even, great SEO guys, you rawk!`}</p>
    <p>{`But then a whole lot of backlash started flying in and Google seemed confused and didn't know what to do. So they created an apologetic adsense thingy saying something to the extent "Yeah, these results are sometimes offensive because the internet is one big cesspool of insanity. Fuck it"`}</p>
    <p>{`It was not enough, earlier this week the result was completely removed from any sort of search for "michelle obama". However it can still be found through a bit of a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Streisand_effect",
        "title": "Streisand effect"
      }}>{`Streissand effect`}</a>{` when you search for "michelle obama monkey"`}</p>
    <p>{`Here's the image:`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/11/michelle-obama-ape.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/11/michelle-obama-ape.jpg",
          "alt": "michelle-obama-ape",
          "title": "michelle-obama-ape"
        }}></img></a></p>
    <p>{`Now, some say this thing is incredibly offensive and goes far beyond political satire just because a black person is involved. Personally I don't care, I think it's specieist towards monkeys when either a black person or `}<a parentName="p" {...{
        "href": "http://doctorbulldog.files.wordpress.com/2009/02/8130george-w-bush-monkey-posters.jpg"
      }}>{`Bush`}</a>{` is shooped into a monkey. Nobody seems to care about that though.`}</p>
    <p>{`So I ask of you, why is it political satire to shoop a white person into a monkey and a horribly horrible sadistic act of racism when a black person is shooped? Isn't making this distinction an act of racism in and of itself thus proving that anyone who actually cares about this matter is in fact a racist?`}</p>
    <p>{`For final summation, a very smart man once said "I may not agree with what you're saying, but I will fight to death for your right to say it". Apparently said wisdom does not hold anymore on the freest medium of all - the internets.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/1ad144d6-554e-457c-aaa7-1e2962d4260c/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=1ad144d6-554e-457c-aaa7-1e2962d4260c",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      